import { useEffect, useRef, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import HeaderBar from "../../../../Components/UI/headerbar";
import StatusBadge from "../../../../Components/UI/statusBadge";
import DataTable from "../../../../Components/UI/table/DataTable";
import TableActions from "../../../../Components/UI/table/TableActions";
import FilterBar from "../../../../Components/UI/filterbar";
import {
  deleteProduct,
  editProduct,
  exportExcelProducts,
  getProducts,
  importExcelProduct,
} from "../../../../MyApi/product";
import { formatPrice } from "../../../../utils/formatPrice";
import { postBulkDelete } from "../../../../MyApi/bulkdelete";
import { useSearchParams } from "react-router-dom";
const ProductIndex = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const pageParam = searchParams.get("page") || 1;
  const [currentPage, setCurrentPage] = useState(pageParam);
  console.log("currentPage", currentPage);
  useEffect(() => {
    setCurrentPage(Number(pageParam));
  }, [pageParam]);
  const [filters, setFilters] = useState({
    search: "",
    is_active: "",
    store_order: "",
    category_id: "",
    store_id: "",
  });
  const [selectedProductsIds, setSelectedProductsIds] = useState([]);

  const navigate = useNavigate();

  const is_vendor = JSON.parse(localStorage.getItem("is_vendor"));
  const { data, isLoading, refetch, isFetching, error } = useQuery(
    ["getProducts", currentPage, filters],
    () => getProducts(filters, currentPage),
    { keepPreviousData: true, staleTime: 5 * 60 * 1000 },
  );
  const queryClient = useQueryClient();
  const mutateBulkDelete = useMutation({
    mutationFn: postBulkDelete,
    onSuccess: (data) => {
      queryClient.invalidateQueries("getProducts");
      toast.success(`${data.message}`);
      setSelectedProductsIds([]);
    },
    onError: (error) => {
      toast.error(error.response?.data?.message || "حدث خطأ أثناء الحذف");
    },
  });

  const importMutation = useMutation({
    mutationFn: importExcelProduct,
    onSuccess: () => {
      toast.success("تم استيراد الملف بنجاح");
    },
    onError: () => {
      toast.error("حدث خطأ أثناء الاستيراد");
    },
  });
  const { mutate, isLoading: isPending } = importMutation;
  const products = data?.data?.products || [];
  const totalItems = data?.data?.pagination?.total || 0;
  const lastPage = data?.data?.pagination?.last_page || 0;

  const handleBulkChecked = (e, id) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setSelectedProductsIds((prev) => [...prev, id]);
    } else {
      setSelectedProductsIds((prev) =>
        prev.filter((productId) => productId !== id),
      );
    }
  };

  const productColumns = [
    {
      label: "تحديد عناصر",
      render: (row) => (
        <input
          type="checkbox"
          checked={selectedProductsIds.includes(row.id)}
          onChange={(e) => handleBulkChecked(e, row.id)}
        />
      ),
    },
    {
      label: "ترتيب العرض",
      accessor: "id",
      render: (row) => <span style={{ color: "green" }}>#{row.id}</span>,
    },

    { label: "اسم المنتج", accessor: "name" },
    { label: " الفئة", accessor: "category.name" },
    {
      label: "صورة المنتج",
      accessor: "image",
      render: (row) => (
        <img
          style={{ color: "green" }}
          width={64}
          height={64}
          src={row.images[0]?.image_path}
          className="rounded-4"
        />
      ),
    },
    // { label: "صورة ", accessor: "image" },

    {
      label: "وقت التحضير",
      render: (row) =>
        row.preparation_time
          ? `${row.preparation_time} ${row.preparation_time_unit || ""}`
          : "___",
    },
    { label: "أقصي كمية في السلة", accessor: "max_cart_quantity" },
    {
      label: "السعر",
      render: (row) =>
        row.price
          ? `${formatPrice(row.currency_factor, row.price)} ${row.symbol_currency || ""}`
          : "___",
    },
    { label: "الخيارات", render: (row) => row.product_options.length },
    { label: "الإضافات", render: (row) => row.add_ons.length },
    ...(!is_vendor
      ? [
          {
            label: "الحالة",
            render: (row) => (
              <div className="add">
                <select
                  value={row.status}
                  onChange={(e) => {
                    const newStatus = e.target.value;

                    editProduct(
                      { _method: "PUT", product: { status: newStatus } },
                      row.id,
                    )
                      .then(() => {
                        toast.success("تم تحديث حالة المنتج بنجاح");
                        refetch();
                      })
                      .catch((error) => {
                        toast.error(
                          error.response?.data?.message ||
                            "حدث خطأ أثناء التحديث",
                        );
                      });
                  }}
                  className="form-select"
                  style={{ width: "150px" }}
                >
                  <option value="active">نشط</option>
                  <option value="inactive">غير نشط</option>
                  <option value="rejected">مرفوض</option>
                  <option value="pending">معلق</option>
                </select>
              </div>
            ),
          },
        ]
      : []),
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          viewPermission={"view_product"}
          editPermission={"update_product"}
          deletePermission={"delete_product"}
          show={() => handleShowProduct(row.id)}
          refetch={refetch}
          edit={() => handleEditProduct(row.id)}
          deleteFn={deleteProduct}
          id={row.id}
          mutationKey={"deleteProduct"}
          togglePermission={"update_product"}
          toggleMutationKey={"toggle-update-product"}
          is_active={row.is_active}
          toggleFn={(id, status) =>
            editProduct({ _method: "PUT", product: { is_active: status } }, id)
          }
        />
      ),
    },
  ];

  const handleShowProduct = (id) => {
    navigate(`${process.env.PUBLIC_URL}/product/${id}`, {
      state: { from: location.pathname + location.search, page: currentPage },
    });
  };

  const handleEditProduct = (id) => {
    navigate(`${process.env.PUBLIC_URL}/product/edit/${id}`, {
      state: { from: location.pathname + location.search, page: currentPage },
    });
  };
  const handleAddClick = () => {
    navigate(`${process.env.PUBLIC_URL}/products/store`, {
      state: { from: location.pathname + location.search },
    });
  };

  let filtersConfig = {
    search: "search",
    is_active: "is_active",
    store_order: "store_order",
    categories: "categories",
    store: "store",
  };
  if (is_vendor) {
    filtersConfig = {
      search: "search",
      is_active: "is_active",
      store_order: "store_order",
      categories: "categories",
    };
  }
  const handleExport = async () => {
    try {
      const res = await exportExcelProducts({});
      console.log("res", res);
      if (res.success === true) {
        toast.success(`${res.message}`);
        navigate(`${process.env.PUBLIC_URL}/downloads`);
      } else {
        toast.error(`حدث خطأ أثناء التصدير`);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    mutate(file);

    e.target.value = null;
  };
  const deleteSelectedProducts = () => {
    if (selectedProductsIds.length === 0) {
      toast.error("يرجي اختيار منتجات لحذفها");
      return;
    }
    mutateBulkDelete.mutate({ ids: selectedProductsIds, type: "product" });
  };
  return (
    <div>
      <HeaderBar
        title={"المنتجات"}
        content={"جميع المنتجات المتاحة في المتاجر"}
      />
      <FilterBar
        setFilters={setFilters}
        filters={filters}
        filtersConfig={filtersConfig}
        placeholder="ابحث باسم المنتج"
      />
      <DataTable
        title={"المنتجات"}
        columns={productColumns}
        data={products}
        onAddClick={handleAddClick}
        excel={true}
        actionLabel={"إضافه منتجات"}
        totalItems={totalItems}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        itemsPerPage={lastPage}
        isLoading={isLoading}
        isFetching={isFetching}
        createPermission={"create_product"}
        error={error}
        onRetry={() => refetch()}
        importExcel={handleButtonClick}
        exportExcel={handleExport}
        handleFileChange={handleFileChange}
        fileInputRef={fileInputRef}
        isPending={isPending}
        isBulkDelete={true}
        deleteSelectedProducts={deleteSelectedProducts}
      />
    </div>
  );
};

export default ProductIndex;
